<template>
    <rd-card type="vertical" margins="none">
        <rd-card-header>
            <rd-header :title="$t('dashboard.topAcceptanceDelays.title')" margins="none" size="medium" />
        </rd-card-header>
        <rd-card-content>
            <dx-data-grid :data-source="topAcceptanceDelays">
                <dx-column :caption="$t('dashboard.topAcceptanceDelays.captions.instanceNumber')"
                           data-type="string"
                           data-field="InstanceNumber" />
                <dx-column :caption="$t('dashboard.topAcceptanceDelays.captions.userName')"
                           data-type="string"
                           data-field="UserName" />
                <dx-column :caption="$t('dashboard.topAcceptanceDelays.captions.purchaseGoal')"
                           data-type="string"
                           data-field="PurchaseGoal" />
            </dx-data-grid>
        </rd-card-content>
    </rd-card>
</template>

<script>
    // @ is an alias to /src
    //import Axios from 'axios';
    //import router from 'vue-router';
    //import sideNav from '../components/sideNav/Index'
    import { mapFields } from 'vuex-map-fields';
    import { mapState, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid'

    const name = "processesStores/pzzDashboardStores/indexStore";

    export default {
        name: 'pzzDashboardTopAcceptanceDelays',
        created() {
            this.setTopAcceptanceDelays();
        },
        data() {
            return {
                
            }
        },
        computed: {
            ...mapState(name, ['topAcceptanceDelays'])
        },
        methods: {
            ...mapActions(name, ['setTopAcceptanceDelays'])
        },
        mounted() {
        },
        beforeDestroy() {
        },
        components: {
            DxDataGrid,
            DxColumn
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
